import { gql } from '@apollo/client'
import { BookmarkActiveIcon, BookmarkIcon, IconButton } from '@farol-ds/react'
import { LoginTrigger } from '@jusbrasil-web/shared-bifrost'

import { useMetrics, useSaveDocument } from '../../hooks'
import { PartialGA4FeatureUseEventProps } from '../ga4-utils'
import { DocSave_DocumentFragment, DocSave_ViewerFragment } from './__generated__/doc-save.graphql'

export interface DocSaveProps {
  document: DocSave_DocumentFragment
  viewer: DocSave_ViewerFragment | null
  ga4EventData?: PartialGA4FeatureUseEventProps
}

export function DocSave(props: DocSaveProps) {
  const { viewer, document, ga4EventData } = props
  const { docId, viewerSaved } = document
  const { ref: dispatcherRef, sendMetrics } = useMetrics<HTMLButtonElement>()
  const { loading, toggleSave } = useSaveDocument({ document, viewer, ga4EventData, sendMetrics })

  const icon = viewerSaved ? <BookmarkActiveIcon /> : <BookmarkIcon />

  return (
    <LoginTrigger isLogged={!!viewer}>
      <IconButton
        ref={dispatcherRef}
        icon={icon}
        label="Salvar"
        onClick={toggleSave}
        loading={loading}
        data-testid={`docsave-${docId}-${viewerSaved ? 'UNSAVE' : 'SAVE'}${
          loading ? ` docsave-${docId}-loading` : ''
        }`}
      />
    </LoginTrigger>
  )
}

DocSave.fragments = {
  document: gql`
    fragment DocSave_document on Document {
      viewerSaved
      ...UseSaveDocument_document
    }
    ${useSaveDocument.fragments.document}
  `,
  viewer: gql`
    fragment DocSave_viewer on Profile {
      pid
      ...UseSaveDocument_viewer
    }
    ${useSaveDocument.fragments.viewer}
  `,
}
